<template>
  <v-dialog :value="isActive" max-width="1200" persistent>
    <v-card class="text-center pop-up" height="100%">
      <v-card-title class="text-sm-left font-weight-bold px-5">
        Kết quả khảo sát
        <v-icon aria-label="Close" @click="closeModal">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="px-9 pt-0">
        <v-row class="align-center">
          <b style="margin-right: 10px">Bộ lọc: </b>
          <v-col cols="12" md="2">
            <v-select
                label="Chọn con"
                item-text="fullName"
                item-value="id"
                :items="customers"
                v-model="customerServey"
                @change="updateCustomerServey"
                class="pick-status-class"
            >

            </v-select>
          </v-col>
          <v-col cols="12" md="2">
            <v-select
                label="Chọn khảo sát"
                :items="typeServey"
                v-model="typeServeySelected"
                item-text="text"
                item-value="id"
                @change="updateTypeSelected"
                class="pick-status-class"
            >

            </v-select>
          </v-col>

        </v-row>
        <br>
        <v-data-table
            :headers="headers"
            :items="dataInteraction"
            :hide-default-footer="true"
        >
          <template
              v-slot:item="{ item }">
            <tr>
              <td class="text-left">
                {{item.time}}
              </td>
              <td class="text-left">
                {{item.result_1}}
              </td>
              <td class="text-left">
                {{item.result_2}}
              </td>
              <td class="text-left">
                {{item.result_3}}
              </td>
              <td class="text-left">
                {{item.result_4}}
              </td>
              <td class="text-left">
                <a :href="item.link" target="_blank" style="color: #0d9aff">Link</a>
              </td>
            </tr>
          </template>
        </v-data-table>
        <v-col class="pb-0"
               style="display: flex; justify-content: flex-end; padding: 0 12px">
          <div class="d-flex">
            <div class="text-right mb-1 mt-2">
              <template v-if="this.totalItemActionLogs">
                {{showContactsIndex()}}
              </template>
              <v-btn
                  small
                  class="pagination-btn-left"
                  :disabled="currentPage == 1"
                  @click="previousPage"
              >
                <v-icon>mdi-menu-left</v-icon>
              </v-btn>
              <v-btn
                  small
                  class="pagination-btn-right"
                  :disabled="currentPage >= getTotalItem(totalItemActionLogs, limit)"
                  @click="nextpage"
              >
                <v-icon>mdi-menu-right</v-icon>
              </v-btn>
            </div>
            <div style="width: 35px" v-if="totalItemActionLogs">
              <v-text-field
                  v-model="pendingPage"
                  :max="getTotalItem(totalItemActionLogs, limit)"
                  class="pt-0"
                  min="1"
                  step="1"
                  type="number"
                  @input="applyPendingPage(getTotalItem(totalItemActionLogs, limit))"
              >
              </v-text-field>
            </div>
          </div>
        </v-col>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
export default {
  name: "ContactStatusFilterForm",
  props: {
    dataInteraction: {
      default: () => ({}),
    },
    contact: {
      default: () => ({}),
    },
    showServeyModal: Boolean,
    totalItemActionLogs: Number,
    currentPage: Number,
    customers: {
      default: () => ([]),
    },
    customerServey: Number,
    typeServey: {
      default: () => ([]),
    },
    typeServeySelected: String,
  },
  data() {
    return {
      page: 1,
      pagination: {},
      rowsPerPageOptions: [50, 100, 150],
      isActive: this.showServeyModal,
      headers: [
        {
          text: "Ngày làm khảo sát",
          align: "start",
          value: "time",
          class: "header-title first-colums",
          sortable: false,
        },
        {
          text: "Kết quả 1",
          align: "start",
          sortable: false,
          value: "result_1",
          class: "header-title ket-qua-1",
        },
        {
          text: "Kết quả 2",
          align: "start",

          value: "result_2",
          sortable: false,
          class: "header-title",
        },

        {
          text: "Kết quả 3",
          align: "start",
          value: "result_3",
          sortable: false,
          class: "header-title",
        },
        {
          text: "Kết quả 4",
          align: "start",
          value: "result_4",
          sortable: false,
          class: "header-title",
        },
        {
          text: "Link",
          align: "start",
          value: "link",
          sortable: false,
          class: "header-title",
        },
      ],
      showErrors: false,
      //currentPage: 1,
      limit: 10,
      totalItem: null,
      pendingPage: 1,
    };
  },
  methods: {
    closeModal() {
      this.isActive = false;
      this.month = null;
      this.year = null;
      this.$emit("closePopUp", false);
    },
    showContactsIndex(){
      let maxIndex = parseInt(this.currentPage)*parseInt(this.limit)
      if (maxIndex >= this.totalItemActionLogs) {
        return (maxIndex - parseInt(this.limit) + 1) + ' - ' + this.totalItemActionLogs
      } else {
        return (maxIndex - parseInt(this.limit) + 1) + ' - ' + maxIndex
      }
    },
    applyPendingPage: _.debounce(function(maxPage) {
      if (this.pendingPage < 1) {
        this.pendingPage = this.currentPage
        this.$emit('update:currentPage',this.currentPage)
        return
      }
      if (this.pendingPage > maxPage) {
        this.pendingPage = maxPage
        this.currentPage = parseInt(this.pendingPage)
        this.$emit('update:currentPage',this.currentPage)
        return
      }
      this.currentPage = parseInt(this.pendingPage)
      this.$emit('update:currentPage',this.currentPage)
      return
    }, 1000),
    nextpage(){
      this.currentPage++
      this.$emit('update:currentPage',this.currentPage)
      this.pendingPage++
    },
    previousPage(){
      this.currentPage--
      this.$emit('update:currentPage',this.currentPage)
      this.pendingPage--
    },
    updateCustomerServey(value) {
      this.pendingPage = 1;
      this.currentPage = 1;
      this.$emit('update:currentPage',this.currentPage)
      this.$emit('update:customerServey', value);
      Bus.$emit('count-list-filter-sersey')
    },
    updateTypeSelected(value) {
      this.$emit('update:typeServeySelected', value);
      Bus.$emit('count-list-filter-sersey');
    }
  },
  created() {
  },
  watch: {
    currentPage: {
      handler() {
        Bus.$emit('count-list-filter-sersey');
      }
    },
  }
};
</script>

<style scoped lang="css" >

/deep/ .v-subheader.theme--light {
  font-size: 10px;
  font-weight: bold;
}
/deep/ .v-data-table table {
  border-spacing: 1px;
}
/deep/ .v-data-table__empty-wrapper td {
  font-weight: 500;
}
.contact-history-table--wrapper {
  max-height: 280px;
  overflow: auto;
}

.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.data-table-dense-header-height {
  font-size: 10px;
  font-weight: bold;
}
#rounded-card {
  position: relative;
  text-align: center;
  border-radius: 50%;
  min-height: 128px;
  min-width: 128px;
  background: yellow;
}

/deep/ .v-tabs-bar {
  height: 30px;
}

/deep/ .v-tab {
  font-size: 12px;
}

/deep/ .v-data-footer__select{
  height: 30px;
}
/deep/ .text-start.header-title{
  font-size: 16px;
  color: #0600ff;
  background: #d0d5ff;
  font-weight: 500;
  font-size: 14px;
}
/deep/ .text-start.ket-qua-1{
  width: 230px;
}
/deep/ .text-start.first-colums{
  width: 150px;
}
/deep/ .text-center.header-title{
  font-size: 16px;
  font-weight: bold;
}
.appointment-time-wrapper {
  padding: 5px;
  border: 1px solid #a9a9a9;
  border-radius: 5px;
  font-weight: 700;
}
.select-option .menuable__content__active{
  background: #FFFFFF!important;
}
</style>
<style lang="scss">
.select-date .v-input__control .v-text-field__details{
  display: none!important;
}
.pagination-btn-left, .pagination-btn-right {
  max-width: 30px !important;
  min-width: 30px !important;
  background-color: #ffffff !important;
}
.pagination-btn-left i, .pagination-btn-right i {
  color: rgba(0,0,0,.54) !important
}
.pagination-btn-left {
  margin: 0px 5px 2px 10px !important;
}
.pagination-btn-right {
  margin: 0px 10px 2px 5px !important;
}
.pick-status-class {
  .v-select__selection--comma {
    color: red !important;
  }
}
</style>
